export const isMobile = {
  Android: () => {
    return navigator.userAgent.match(/Android/i);
  },
  iOS: () => {
    return navigator.userAgent.match(/iPhone|iPad|iPod/i);
  },
  Opera: () => {
    return navigator.userAgent.match(/Opera Mini/i);
  },
  Windows: () => {
    return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
  },
  screenSize: () => {
    return document.body.clientWidth < 991;
  },
  any: () => {
    return ((isMobile.Android() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows()) && isMobile.screenSize());
  }
};